<ng-container *ngIf="isBuiIconMaterialIconType | wrapFn : type">
  <mat-icon [svgIcon]="type + ':' + name" [inline]="inline"></mat-icon>
</ng-container>

<ng-container *ngIf="type === iconCustom">
  <app-svg-icon [icon]="name"></app-svg-icon>
</ng-container>
